// https://github.com/codiini/react-audio-video-recorder/blob/main/src/AudioRecorder.jsx
import { useState, useEffect } from "react";
import { getImage, getValue } from "../db/db";
import { FaEdit, FaTrash } from 'react-icons/fa'
import { RemoveDialogButton } from "./AlertDialog";
import { useSelector } from "react-redux";
import { editCard } from "../store/cards.dispatch";

export const MMCard = ({ cardId }) => {

  const [audio, setAudio] = useState(null);
  const [hasRecording, setHasRecording] = useState(false);
  const [playerId, setPlayerId] = useState(null);
  const isEditingDashboard = useSelector(state => state.config.editableDashboard);
  const [bgImage, setBgImage] = useState(null);

  useEffect(() => {
    setPlayerId(`player-${cardId}`);
  }, [cardId]);

  const loadAudioUsingCardId = async ({ cardId }) => {
    const audioBlob = await getValue({ key: cardId });
    if (audioBlob) {
      const audioUrl = URL.createObjectURL(audioBlob);
      setAudio(audioUrl);
      setHasRecording(true)
    }
  }

  useEffect(() => {
    loadAudioUsingCardId({ cardId });
    getImage({ cardId })
      .then(img => setBgImage(img))
  }, [cardId])

  const playAudio = (force = false) => {
    if ((isEditingDashboard) && (!force)) return
    document.getElementById(playerId).currentTime = 0;
    document.getElementById(playerId).play();
  }

  const handleTrash = async () => alert('remove handler');
  const editHandler = () => editCard(cardId);

  return (
    (audio && playerId) ? (
      <div
        className="audio-player rounded-md shadow-md cursor-pointer flex flex-col py-2 w-full h-full flex-1 justify-center items-center gap-2"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
        }}
        onClick={() => playAudio(false)}
      >
        <audio id={playerId} src={audio}></audio>
        {isEditingDashboard &&
          <div className="flex flex-row bg-c2 glass p-2 rounded-md justify-center items-center gap-2">
            <FaEdit
              className="c4"
              style={{ fontSize: '2rem' }}
              onClick={editHandler}
            />
            <FaTrash
              className="z-10 warn"
              style={{ fontSize: '1rem', zIndex: 9999 }}
              onClick={handleTrash}
            />
            <RemoveDialogButton cardId={cardId} />
          </div>}
      </div>
    ) : null
  );
};